import moment from "moment";
import { CompanyRequest, CompanyResponse } from "./../company/companyContracts";
export class SiteDetail {
}
export class SiteRequest extends CompanyRequest {
}
export class SiteResponse extends CompanyResponse {
}
export let defaultSiteDetail = {
    cqcRatingDate: moment(new Date()).format("YYYY-MM-DD"),
    registeredActivities: "",
    website: "",
    safe: "",
    effective: "",
    caring: "",
    responsive: "",
    wellLed: "",
    financialMonth: "",
    noOfRegisteredBeds: null,
    ingestionYear: "",
    financialSystemText: "",
    weight: 0,
    integrationCredentials: []
};
